<app-sidemenu></app-sidemenu>
<div class="ion-page" id="main-content">

  @if ((user | async) && isVisible) {
  <app-navbar></app-navbar>
  }

  <ion-content class="ion-padding">
    <ng-content></ng-content>
  </ion-content>
  @if (moovingAssistant) {
  <app-ia-assistant [user]="(user | async)!" 
  [moovingAssistant]="moovingAssistant" 
  [messages]="messages" ></app-ia-assistant>
  }


</div>